define('uikit/collections/breadcrumb',['require','exports','module','underscore','marionette','../extra/size','../channel','../templates','../mixins/component.mixin','./components.container.view'],function(require, exports, module){
  var _              = require('underscore');
  var Mn             = require('marionette');
  var Size           = require('../extra/size');
  var channel        = require('../channel');
  var Templates      = require('../templates');
  var ComponentMixin = require('../mixins/component.mixin');
  var ComponentsContainerView = require('./components.container.view');

  var BreadcrumbItem = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'section',

    template: Templates.UIKit['breadcrumb'],

    options: {
      text: null,
      link: null,
      icon: null,
      muted: null
    },

    forceUpdate: {
      text: true,
      muted: true
    },

    allowTagChange: true,

    updateAttributes: function() {
      if (_.isString(this.getOption('link'))) {
        this.$el.attr('href', this.getOption('link'))
      } else {
        this.$el.removeAttr('href');
      }
    }
  });

  var Breadcrumb = ComponentsContainerView.extend({
    className: 'ui breadcrumb',

    tagName: 'nav',

    options: {
      size: '',
      divider: '/',
      dividerIcon: null
    },

    sizeOptionValues: _.values(Size),

    childView: BreadcrumbItem,

    events: {
      'keydown .section': function(ev) {
        if (ev.keyCode == 13) {
          this.triggerSectionPress(ev);
        }
      },
      'click .section': 'triggerSectionPress'
    },

    initialize: function() {
      ComponentsContainerView.prototype.initialize.apply(this, arguments);

      this.updateElementAttributes({'aria-label': 'Breadcrumbs'});

      this.listenTo(this.collection, 'reset', this._clearDividersOnReset);

      this.listenTo(this.collection, 'update', this._requestRender);
    },

    _clearDividersOnReset: function() {
      this.$el.contents().remove();
    },

    _createBuffer: function() {
      var oldElBuffer = ComponentsContainerView.prototype._createBuffer.apply(this, arguments);
      var newBuffer = document.createDocumentFragment();
      var index = 0;
      var len = oldElBuffer.childNodes.length;

      while(oldElBuffer.childNodes.length > 0) {
        childNode = oldElBuffer.childNodes[0];
        newBuffer.appendChild(childNode);
        if (index !== len-1) {
          newBuffer.appendChild(this.createDividerElement());
        }
        index++;
      }
      return newBuffer;
    },

    createDividerElement: function() {
      return $(Templates.UIKit['breadcrumb.divider']({
        divider: this.getOption('divider'),
        dividerIcon: this.getOption('dividerIcon')
      })).get(0);
    },

    buildChildView: function(child, ChildViewClass, childViewOptions) {
      var options = _.extend({}, childViewOptions, {
        isFirst: this.collection.first() == child,
        isLast: this.collection.last() == child
      });

      return ComponentsContainerView.prototype.buildChildView.call(this, child, ChildViewClass, options);
    },

    triggerSectionPress: function(ev) {
      var el    = $(ev.currentTarget),
          index = Number(el.data('index'));

      if (!_.isNaN(index)) {
        this.triggerMethod('section:press', this.collection.at(index), index);
      }
    },

    updateAttributes: function() {
      this.addClass(this.getOption('size'));
    }
  });

  channel.reply('breadcrumb', function() {
    return Breadcrumb;
  });

  module.exports = Breadcrumb;
});

